import cn from "classnames";
import styles from "./MergeItem.module.scss";
import MinerName from "@components/global/new/MinerName/MinerName";

export interface IMergeItem3Props {
  readonly minerName: string; //rackItem.miner_name
  readonly className?: string;
}

const MergeItem3 = (props: IMergeItem3Props) => {
  const { className } = props;
  return (
    <div className={cn(styles.wrapper, className)}>
      <MinerName>{props.minerName}</MinerName>
    </div>
  );
}

export default MergeItem3;